import React from 'react';
import styled from 'styled-components';
import { ButtonText } from 'components/atoms/Text';

const ButtonContainer = styled.div`
    background: ${(props) => (props.active ? '#B23414' : 'white')};
    border-radius: 6px;
    border: ${(props) => (!props.active ? '1px solid #B23414' : '0px')};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-left: 14px;
    padding-right: 14px;
    height: 36px;
    width: ${(props) => (props.width ? props.width : 'fit-content')};

    &:hover {
        cursor: pointer;
        ${(props) => (props.active ? 'background-color: #801F06' : '')};
    }
`;

const AlternativeButton = ({ text, active = false, width = null, ...props }) => {
    return (
        <ButtonContainer active={active} width={width} {...props}>
            <ButtonText style={{ color: !active ? '#B23414' : 'white', fontSize: 14 }}>{text}</ButtonText>
        </ButtonContainer>
    );
};

export default AlternativeButton;
